export const SORT_TYPES = {
  ASC: "asc",
  DESC: "desc",
};

export const TARIFFS = {
  LITE: "lite_p",
  PROMO: "promo_p",
  PRO: "pluspro_p",
  CORP: "corporate",
};

export const MAX_TP_IN_TARIFF = {
  LITE: 5,
  PROMO: 15,
  PRO: 30,
};

export const RATING_FILTER = [
  { rating: 5, value: false, total: 0 },
  { rating: 4, value: false, total: 0 },
  { rating: 3, value: false, total: 0 },
  { rating: 2, value: false, total: 0 },
  { rating: 1, value: false, total: 0 },
];

export const TARIFF_SORT = Object.values(TARIFFS);
